var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [_c("carbon-dashboard"), _c("project-kpis"), _c("budget-dashboard")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }